(function () {
  function init() {
    var els = document.querySelectorAll('.reveal:not([data-reveal-bound])');
    if (!els.length) return;

    els.forEach(function (el) {
      el.setAttribute('data-reveal-bound', '1');
      el.classList.add('js-pending');
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      // threshold 0 + a generous bottom rootMargin so tall elements (like the
      // COA grid, which can be many times the viewport height) reveal as
      // soon as they start entering view, rather than needing a large
      // fraction of their own height on screen at once.
      { threshold: 0, rootMargin: '0px 0px -5% 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);

      // Safety net: only for elements already on/near screen at bind time,
      // in case the observer callback is slow to fire for them on some
      // in-app browsers or webviews. Elements further down the page must
      // NOT get this treatment, or they'd be force-revealed long before the
      // person ever scrolls near them, making the animation invisible.
      var rect = el.getBoundingClientRect();
      var nearViewport = rect.top < (window.innerHeight * 1.15);
      if (nearViewport) {
        setTimeout(function () {
          if (!el.classList.contains('in')) {
            el.classList.add('in');
          }
        }, 800);
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
